/**
 * RC time constant: τ = R × C
 * Accepts suffixes: 10k, 1uF, 100nF, etc.
 */

import React, { useState, useMemo } from 'react';
import { parseEngineering, inputClass, resultClass, labelClass, hintClass } from './parseEngineering';

const ts = () => new Date().toISOString();

const RcTimeConstant = () => {
  const [r, setR] = useState('');
  const [c, setC] = useState('');

  console.log(`[${ts()}] [RcTimeConstant] render`);

  const rNum = useMemo(() => {
    const v = parseEngineering(r);
    return v != null && v > 0 ? v : null;
  }, [r]);
  const cNum = useMemo(() => {
    const v = parseEngineering(c);
    return v != null && v > 0 ? v : null;
  }, [c]);

  const tau = useMemo(() => {
    if (rNum == null || cNum == null) return null;
    return rNum * cNum;
  }, [rNum, cNum]);

  const formatTime = (t) => {
    if (t >= 1) return t.toFixed(4) + ' s';
    if (t >= 1e-3) return (t * 1e3).toFixed(4) + ' ms';
    if (t >= 1e-6) return (t * 1e6).toFixed(4) + ' µs';
    return (t * 1e9).toFixed(4) + ' ns';
  };

  return (
    <div className="space-y-4">
      <p className={hintClass}>
        τ = R × C. Use suffixes: 10k, 1uF, 100nF, 2.2mF, etc.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className={labelClass}>Resistance R</label>
          <input
            type="text"
            value={r}
            onChange={(e) => setR(e.target.value)}
            placeholder="e.g. 10k or 10000"
            className={inputClass}
          />
        </div>
        <div>
          <label className={labelClass}>Capacitance C</label>
          <input
            type="text"
            value={c}
            onChange={(e) => setC(e.target.value)}
            placeholder="e.g. 1uF or 100nF"
            className={inputClass}
          />
        </div>
      </div>
      {tau != null && (
        <div className={resultClass}>
          <div>
            <span className="text-gray-600 text-sm">Time constant τ: </span>
            <span className="font-semibold text-gray-900">{formatTime(tau)}</span>
          </div>
          <div className="text-gray-500 text-xs mt-1">
            ~63% charge in τ, ~95% in 3τ, ~99% in 5τ
          </div>
        </div>
      )}
    </div>
  );
};

export default RcTimeConstant;
